import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GetFacilitiesList } from "../../../utilities/api/Facilities";
import { messages } from "../../../utilities/Messages";

type ErrorMessageType = {
  message: string;
}

type FacilityListType = {
  createdAt: string
  name: string
  address: string
  id: string
  status: string
  latitude: string
  longitude: string
}
type SelectedFacilityType = string

const initialState = {
  AllFacilitiesData: [] as FacilityListType[],
  SelectedFacility: "" as SelectedFacilityType,
  errorMessage: {} as ErrorMessageType,
}

export const AllFacilitiesList = createAsyncThunk(
  "FacilitiesList/AllFacilitiesList",
  (isActive: string = "") => GetFacilitiesList(isActive)
);

const FacilitiesListSlice = createSlice({
  name: "FacilitiesList",
  initialState,
  reducers: {
    selectFacility: (state, action: PayloadAction<string>) => {
      state.SelectedFacility = action.payload
    }
  },
  extraReducers: (builder) => {
    builder

      .addCase(
        AllFacilitiesList.fulfilled,
        (state, action: PayloadAction<any>) => {
          if (action.payload.statusCode === 200) {
            state.AllFacilitiesData = action.payload.data.rows.map(
              (item: any) => ({
                name: item.name,
                createdAt: item.createdAt,
                address: `${item.address.addressLine1}${item.address.addressLine2
                  ? ", " + item.address.addressLine2
                  : ""
                  }${item.address.landmark ? ", " + item.address.landmark : ""
                  }, ${item.address.city}, ${item.address.state}, ${item.address.country
                  }, ${item.address.pincode} `,
                id: item.id,
                status: item.isActive ? "Active" : "Inactive",
                latitude: item.address?.latitude,
                longitude: item.address?.longitude
              })
            );
          }
        }
      )
      .addCase(AllFacilitiesList.rejected, (state, action) => {
        state.errorMessage = { message: messages.error.internal_server_error };
      });

  },
});

export default FacilitiesListSlice.reducer;
export const { selectFacility } = FacilitiesListSlice.actions;
